import React, { useState } from "react";
import { useAxiosContext } from "../../context/AxiosContext";
import Button from "../../components/FormComponents/Button";

const SyncCongnitoUser = ({ path, label = "Sync", HandlePostCall = () => {} }) => {
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const [loading, setLoading] = useState(false);

  const syncCognito = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(path);
      HandlePostCall(response);
      handleSuccess(response.message);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="secondary" onClick={syncCognito} isLoading={loading}>
      {label}
    </Button>
  );
};

export default SyncCongnitoUser;
